module.exports = __webpack_public_path__ + "img/Romantikken_norsk-juleskikk.98f5264e.jpg";